import Navbar from './screens/Navbar/Navbar';
import { Routes, Route } from "react-router-dom";
import './App.css';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module'

// Screens
import Home from './screens/Home/Home';
import Footer from './screens/Footer/Footer';
import Careers from './screens/Careers/Careers';
import About from './screens/About/About';
import Contact from './screens/Contact/Contact';
import Learning from './screens/Learning/Learning';
import Legal from './components/Legal';
import NotFound from './screens/NotFound';
import Popup from './components/Popup';
import StickyApply from './components/StickyApply';
import Guides from './screens/Guides/Guides';

const tagManagerArgs = {
  gtmId: 'GTM-N9JP9JC',
}

function App() {
  const [menu, setMenu] = useState(false)
  const [currentScreen, setCurrentScreen] = useState(null)
  const [isEnglish, setIsEnglish] = useState(false)
  const [open, setOpen] = useState(false)
  const [monte, setMonte] = useState(false)
  useEffect(() => { setMonte(true) }, [])

  useEffect(() => {
    setCurrentScreen(window.location.pathname)
    setIsEnglish(localStorage.getItem("language") === 'EN')
    TagManager.initialize(tagManagerArgs)
  }, [])

  // Titre + description PAR PAGE (et par langue) : un titre unique pour tout
  // le site diluait le SEO sur « dentiste salarié France », « salaire
  // dentiste », etc. La langue du document suit aussi la langue choisie.
  useEffect(() => {
    const PAGES = {
      '/careers': {
        fr: ['Postes de dentiste et orthodontiste à Châteauroux (Indre) | Neomed France', "Salariat à 30 % et plus des revenus, 6 000 à 20 000 € nets/mois constatés, 4 jours par semaine, zéro administratif. Cabinets à Châteauroux, Déols et Saint-Maur, Indre (36), à 2 h de Paris. Postulez en 2 minutes."],
        en: ['Dentist & orthodontist jobs in Châteauroux, France | Neomed France', 'Salaried at 30%+ of revenue, €6,000–20,000 net/month in practice, 4-day week, zero admin work. Clinics in Châteauroux, Déols and Saint-Maur (Indre), 2h from Paris. Apply in 2 minutes.'],
      },
      '/guides/devenir-dentiste-en-france': {
        fr: ['Devenir dentiste en France avec un diplôme UE — guide 2026 | Neomed France', "Reconnaissance automatique du diplôme, inscription à l'Ordre en ~2 mois, bootcamp de français, salaires réels 6-20 000 € nets/mois. Le parcours complet, étape par étape."],
        en: ['Becoming a dentist in France with an EU degree — 2026 guide | Neomed France', 'Automatic diploma recognition, Ordre registration in ~2 months, French bootcamp, real salaries €6-20,000 net/month. The complete path, step by step.'],
      },
      '/guides/inscription-ordre-chirurgiens-dentistes': {
        fr: ["Inscription à l'Ordre des chirurgiens-dentistes (diplôme UE) : documents et délais | Neomed", "Dossier, entretien, délai réel d'environ 2 mois : la procédure d'inscription au tableau de l'Ordre pour un dentiste diplômé de l'UE — et comment nous la gérons avec vous."],
        en: ['Registering with the French dental council with an EU degree | Neomed France', 'File, interview, real ~2 month timeline: the Ordre registration procedure for an EU-trained dentist — and how we handle it with you.'],
      },
      '/guides/salaire-dentiste-france': {
        fr: ['Salaire dentiste en France 2026 : les vrais chiffres | Neomed France', "6 000 à 20 000 € nets/mois pour un omnipraticien salarié, 8 à 20 000 € pour un orthodontiste : les chiffres réels de nos cabinets, et ce qui fait varier la rémunération."],
        en: ['Dentist salary in France 2026: the real numbers | Neomed France', '€6,000-20,000 net/month for a salaried GP dentist, €8-20,000 for an orthodontist: real numbers from our clinics, and what drives pay.'],
      },
      '/guides/dentist-in-franta': {
        fr: ["Dentist în Franța cu diplomă din UE: ghidul complet 2026 | Neomed France", "Diplomă UE recunoscută automat, venituri constatate de 6.000–20.000 € NET/lună, 4 zile pe săptămână. Pașii reali, Ordinul și franceza."],
        en: ["Dentist în Franța cu diplomă din UE: ghidul complet 2026 | Neomed France", "Diplomă UE recunoscută automat, venituri constatate de 6.000–20.000 € NET/lună, 4 zile pe săptămână. Pașii reali, Ordinul și franceza."],
      },
      '/guides/dentista-em-franca': {
        fr: ["Dentista em França com diploma da UE: guia completo 2026 | Neomed France", "Diploma da UE reconhecido em França. Na Neomed: 6000 a 20 000 € líquidos/mês registados, semana de 4 dias, Ordem em ~2 meses."],
        en: ["Dentista em França com diploma da UE: guia completo 2026 | Neomed France", "Diploma da UE reconhecido em França. Na Neomed: 6000 a 20 000 € líquidos/mês registados, semana de 4 dias, Ordem em ~2 meses."],
      },
      '/guides/dentista-en-francia': {
        fr: ["Dentista en Francia con título de la UE: guía completa 2026 | Neomed France", "Título de la UE reconocido sin examen, de 6.000 a 20.000 € netos al mes observados y colegiación en unos 2 meses. Pasos, plazos y cifras reales."],
        en: ["Dentista en Francia con título de la UE: guía completa 2026 | Neomed France", "Título de la UE reconocido sin examen, de 6.000 a 20.000 € netos al mes observados y colegiación en unos 2 meses. Pasos, plazos y cifras reales."],
      },
      '/guides/odontiatros-sti-gallia': {
        fr: ["Οδοντίατρος στη Γαλλία με πτυχίο ΕΕ: ο πλήρης οδηγός 2026 | Neomed France", "Οδοντίατρος στη Γαλλία: αυτόματη αναγνώριση πτυχίου ΕΕ, 6.000–20.000 € καθαρά/μήνα, 4ήμερη εβδομάδα. Βήματα, γαλλικά, Σύλλογος, προθεσμίες."],
        en: ["Οδοντίατρος στη Γαλλία με πτυχίο ΕΕ: ο πλήρης οδηγός 2026 | Neomed France", "Οδοντίατρος στη Γαλλία: αυτόματη αναγνώριση πτυχίου ΕΕ, 6.000–20.000 € καθαρά/μήνα, 4ήμερη εβδομάδα. Βήματα, γαλλικά, Σύλλογος, προθεσμίες."],
      },
      '/about': {
        fr: ['Qui sommes-nous ? — Neomed France, cabinets dentaires à Châteauroux (Indre)', "Trois cabinets modernes à Châteauroux, Déols et Saint-Maur, notés 4,8/5 par les patients. Découvrez l'équipe et notre façon de pratiquer."],
        en: ['About us — Neomed France, modern dental clinics in Châteauroux', 'Three modern clinics in the heart of France, rated 4.8/5 by patients. Meet the team and how we practice.'],
      },
      '/learning': {
        fr: ['Formation continue des praticiens — Neomed | Implantologie avec le Dr Erwan Hauchard', "Des sessions régulières au cabinet, en théorie et en pratique. Dernière session : implantologie avec le Dr Erwan Hauchard, enseignant à l'Université Paris Cité — poses d'implants assistées sur nos patients."],
        en: ['Continuing education for our dentists — Neomed | Implantology with Dr Erwan Hauchard', 'Regular in-clinic sessions, theory and practice. Latest session: implantology with Dr Erwan Hauchard, who teaches at Université Paris Cité — assisted implant placements on our patients.'],
      },
      '/legal': {
        fr: ['Mentions légales — Neomed France', 'Éditeur ADS Groupe SASU, Déols (Indre) : mentions légales du site neomed.fr.'],
        en: ['Legal notice — Neomed France', 'Publisher ADS Groupe SASU, Déols (Indre): legal notice of neomed.fr.'],
      },
      '/contact': {
        fr: ['Contact & candidature — Neomed France, Châteauroux (Indre) | Réponse sous 24 h', 'Postulez en 2 minutes ou réservez un appel : WhatsApp, téléphone, email. Réponse sous 24 h ouvrées.'],
        en: ['Contact & application — Neomed France, Châteauroux | Reply within 24h', 'Apply in 2 minutes or book a call: WhatsApp, phone, email. Reply within one business day.'],
      },
    }
    const fallback = {
      fr: ['Neomed France — emplois dentistes & orthodontistes à Châteauroux (Indre)', "Une nouvelle génération de cabinets dentaires à Châteauroux, Déols et Saint-Maur, Indre (36), à 2 h de Paris. Dentistes et orthodontistes diplômés de l'UE bienvenus : 6 000 à 20 000 € nets/mois, planning plein dès le premier jour."],
      en: ['Neomed France — dentist & orthodontist jobs in Châteauroux, France', 'A new generation of private dental clinics in Châteauroux, Déols and Saint-Maur (Indre), 2h from Paris. EU-trained dentists and orthodontists welcome: €6,000–20,000 net/month, full schedule from day one.'],
    }
    const lang = isEnglish ? 'en' : 'fr'
    const [title, description] = (PAGES[currentScreen] || fallback)[lang]
    document.title = title
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.content = description
    document.documentElement.lang = lang
    // Canonical + Open Graph alignés sur la page courante.
    const path = !currentScreen || currentScreen === '/' || currentScreen === '/home' ? '' : currentScreen
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = `https://neomed.fr${path}`
    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) ogTitle.content = title
    const ogDescription = document.querySelector('meta[property="og:description"]')
    if (ogDescription) ogDescription.content = description
    // hreflang : le guide « devenir dentiste en France » existe en 5 langues.
    // Sans ces annotations, Google traite les versions comme des pages isolées
    // (voire servies à la mauvaise audience). Retirées hors cluster.
    const HREFLANG_CLUSTER = {
      '/guides/devenir-dentiste-en-france': 'fr',
      '/guides/dentist-in-franta': 'ro',
      '/guides/dentista-em-franca': 'pt',
      '/guides/dentista-en-francia': 'es',
      '/guides/odontiatros-sti-gallia': 'el',
    }
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(l => l.remove())
    if (HREFLANG_CLUSTER[currentScreen]) {
      const targets = [
        ...Object.entries(HREFLANG_CLUSTER).map(([p, l]) => [l, p]),
        ['x-default', '/guides/devenir-dentiste-en-france'],
      ]
      for (const [code, p] of targets) {
        const link = document.createElement('link')
        link.rel = 'alternate'
        link.hreflang = code
        link.href = `https://neomed.fr${p}`
        document.head.appendChild(link)
      }
      // La page elle-même est dans la langue du guide, pas fr/en.
      document.documentElement.lang = HREFLANG_CLUSTER[currentScreen]
    }
  }, [isEnglish, currentScreen])

  return (
    <div className="App overflow-x-hidden">
      <Navbar menu={menu} setMenu={setMenu} setCurrentScreen={setCurrentScreen} currentScreen={currentScreen} isEnglish={isEnglish} setIsEnglish={setIsEnglish} />

      <Routes>
        <Route path="/" element={<Home isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/home" element={<Home isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/careers" element={<Careers isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/about" element={<About isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/contact" element={<Contact isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/learning" element={<Learning isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/legal" element={<Legal isEnglish={isEnglish} setCurrentScreen={setCurrentScreen} />} />
        <Route path="/guides/:slug" element={<Guides isEnglish={isEnglish} />} />
        <Route path='*' element={<NotFound isEnglish={isEnglish} />} />
      </Routes>

      {/* Après montage : le Dialog Headless UI rend un <span hidden> pendant

          l'hydratation, absent du HTML prérendu → hydratation cassée (04/11/2026). */}

      {monte && <Popup setOpen={setOpen} open={open} isEnglish={isEnglish} />}
      <StickyApply isEnglish={isEnglish} />
      <Footer isEnglish={isEnglish} />
    </div>
  );
}

export default App;
